(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dossier-longevite"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.dlReady) return;
      root.dataset.dlReady = '1';

      // Carrousel des vidéos
      var row = root.querySelector('[data-dl-vrow]');
      root.querySelectorAll('[data-dl-scroll]').forEach(function (b) {
        b.addEventListener('click', function () { if (row) row.scrollBy({ left: +b.dataset.dlScroll * 246, behavior: 'smooth' }); });
      });

      // Carrousel du glossaire (flèches, position) et liens « Relire le mot … » des vrai ou faux de l'annexe
      var gcar = root.querySelector('[data-dl-gcar]');
      if (gcar) {
        var gcards = [].slice.call(gcar.children);
        var gpos = root.querySelector('[data-dl-gpos]');
        var step = function () { return gcards[0].offsetWidth + 14; };
        root.querySelectorAll('[data-dl-g]').forEach(function (b) {
          b.addEventListener('click', function () { gcar.scrollBy({ left: +b.dataset.dlG * step(), behavior: 'smooth' }); });
        });
        gcar.addEventListener('scroll', function () {
          if (gpos) gpos.textContent = Math.min(Math.round(gcar.scrollLeft / step()) + 1, gcards.length) + ' / ' + gcards.length;
        }, { passive: true });
        root.querySelectorAll('[data-dl-mot]').forEach(function (a) {
          a.addEventListener('click', function (e) {
            var card = root.querySelector('#mot-' + a.dataset.dlMot);
            if (!card) return;
            e.preventDefault();
            gcar.scrollIntoView({ behavior: 'smooth', block: 'center' });
            gcar.scrollTo({ left: card.offsetLeft - gcar.offsetLeft, behavior: 'smooth' });
            card.classList.add('is-flash');
            setTimeout(function () { card.classList.remove('is-flash'); }, 2200);
          });
        });
      }

      // Liens des e-mails : ?rep=vf2-faux#vf-2 → rappel de la réponse cliquée
      var rep = new URLSearchParams(window.location.search).get('rep') || '';
      var m = /^vf(\d+)-(vrai|faux)$/.exec(rep);
      if (m) {
        var card = root.querySelector('#vf-' + m[1]);
        if (card) {
          var good = card.getAttribute('data-answer');
          var you = card.querySelector('.dl-vf__you');
          you.textContent = m[2] === good
            ? 'Vous avez répondu « ' + m[2] + ' » : bien vu.'
            : 'Vous avez répondu « ' + m[2] + ' » : c’est en fait ' + good + '.';
          you.hidden = false;
          card.classList.add('is-flash');
          setTimeout(function () { card.classList.remove('is-flash'); }, 2500);
        }
      }

      // Liens du quiz : ?rep=q2-b#quiz-2 → la réponse cliquée est mise en avant (pas de bonne réponse)
      var q = /^q(\d+)-([abc])$/.exec(rep);
      if (q) {
        var qc = root.querySelector('#quiz-' + q[1]);
        var li = qc && qc.querySelector('.dl-qans li[data-k="' + q[2] + '"]');
        if (li) {
          li.classList.add('is-you');
          var yq = qc.querySelector('.dl-vf__you');
          yq.textContent = 'Votre réponse : ' + q[2].toUpperCase() + '. Voici ce que la recherche a mesuré.';
          yq.hidden = false;
          qc.classList.add('is-flash');
          setTimeout(function () { qc.classList.remove('is-flash'); }, 2500);
        }
      }

      // Newsletter : même point d'entrée Klaviyo que le formulaire du blog (theme-apm.js)
      root.querySelectorAll('[data-dl-nl]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var input = form.querySelector('input[type="email"]');
          var ok = form.querySelector('.dl-nl__msg--ok');
          var err = form.querySelector('.dl-nl__msg--err');
          ok.hidden = true; err.hidden = true;
          var email = (input.value || '').trim().toLowerCase();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.hidden = false; return; }
          var data = new URLSearchParams({
            g: form.getAttribute('data-list'),
            $fields: '$source,$email,$consent,Accepts Marketing',
            email: email,
            $source: 'Dossier Longévité · hub',
            $consent: 'email',
            'Accepts Marketing': true
          });
          fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', { method: 'POST', body: data })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res && res.errors && res.errors.length) { err.hidden = false; return; }
              ok.hidden = false; input.value = '';
            })
            .catch(function () { err.hidden = false; });
        });
      });
    }
    function boot() { document.querySelectorAll('.dl-hub').forEach(init); }
    // Liens des e-mails (#piece-N, #vf-N) : le thème remonte la page au chargement, on recale sur l'ancre.
    window.addEventListener('load', function () {
      var id = decodeURIComponent((window.location.hash || '').slice(1));
      if (!/^((piece|vf|video|quiz)-\d+|quiz|cercle|rejoindre)$/.test(id)) return;
      var t = document.getElementById(id);
      if (t && t.closest('.dl-hub')) setTimeout(function () { t.scrollIntoView({ block: 'start' }); }, 300);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.dl-hub')); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-goliate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(c) { return (c / 100).toFixed(2).replace('.', ',') + '€'; }

    function init(root) {
      if (root.__lgx) return;
      root.__lgx = true;
      if (/[?&]etat=epuise\b/.test(location.search)) root.classList.add('is-soldout');
      var soldout = root.classList.contains('is-soldout');
      var t1 = +root.dataset.t1 * 100, t2 = +root.dataset.t2 * 100, t3 = +root.dataset.t3 * 100;
      var max = soldout ? t2 : t3;
      var giftId = root.dataset.gift ? +root.dataset.gift : 0;

      // Repères de la barre : position selon le palier ; le dernier palier visible est calé à droite.
      root.querySelectorAll('[data-lgx-mk]').forEach(function (mk) {
        var v = +mk.getAttribute('data-lgx-mk') * 100;
        if (v >= max) mk.classList.add('is-end'); else mk.style.left = (v / max * 100) + '%';
      });

      var el = function (s) { return root.querySelector(s); };
      var total = 0;
      function render(cart) {
        total = cart.total_price || 0;
        var hasGift = giftId && (cart.items || []).some(function (it) { return it.product_id === giftId; });
        el('[data-lgx-total]').textContent = money(total);
        el('[data-lgx-bar]').style.width = Math.min(100, total / max * 100) + '%';
        var b = '<b>', e = '</b>', m;
        if (total === 0) m = 'Ajoutez un soin pour voir votre progression.';
        else if (total < t1) m = 'Plus que ' + b + money(t1 - total) + e + ' pour recevoir 2 échantillons offerts.';
        else if (total < t2) m = '2 échantillons offerts. Plus que ' + b + money(t2 - total) + e + ' pour la livraison offerte.';
        else if (soldout) m = '2 échantillons et livraison offerts.';
        else if (total >= t3) m = b + 'Votre baume confort intime est dans votre panier.' + e + ' Avec 2 échantillons et la livraison offerts.';
        else m = 'Échantillons et livraison offerts. Plus que ' + b + money(t3 - total) + e + ' pour votre baume offert.';
        el('[data-lgx-msg]').innerHTML = m;
        el('[data-lgx-samples]').classList.toggle('is-on', total >= t1);
        el('[data-lgx-giftline]').classList.toggle('is-on', !soldout && (total >= t3 || hasGift));
        var mini = el('[data-lgx-mini]');
        if (mini && !soldout) mini.textContent = total === 0 ? 'dès ' + (t3 / 100) + '€ d\'achat' : (total < t3 ? 'Plus que ' + money(t3 - total) : 'Dans votre panier ✓');
      }
      var timer;
      function refresh() {
        clearTimeout(timer);
        timer = setTimeout(function () {
          fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
            .then(function (r) { return r.json(); }).then(render).catch(function () {});
        }, 250);
      }
      refresh();
      ['rebuild-cart', 'product:added', 'cart:updated'].forEach(function (ev) { document.addEventListener(ev, refresh); });
      window.addEventListener('pageshow', refresh);
      // Toute modification du panier ailleurs (tiroir, appli de cadeau) : relire le panier.
      if ('PerformanceObserver' in window) {
        try {
          new PerformanceObserver(function (list) {
            if (list.getEntries().some(function (en) { return /\/cart\/(add|change|update|clear)/.test(en.name); })) refresh();
          }).observe({ type: 'resource' });
        } catch (err) {}
      }

      root.querySelectorAll('form.lgx-add').forEach(function (form) {
        form.addEventListener('submit', function (ev) {
          if (!window.fetch) return;
          ev.preventDefault();
          var btn = form.querySelector('button');
          btn.disabled = true;
          var fd = new FormData(form);
          fd.append('sections', 'cart-drawer,cart-preview');
          fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
            .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
            .then(function (data) {
              if (data.sections && window.__renderCartFromSections) window.__renderCartFromSections(data.sections);
              if (window.__updateCartData) window.__updateCartData();
              document.dispatchEvent(new CustomEvent('product:added'));
              btn.textContent = 'Ajouté ✓';
              btn.classList.add('is-in');
              setTimeout(function () { btn.textContent = 'Ajouter'; btn.disabled = false; }, 1600);
              refresh();
            })
            .catch(function () { form.submit(); });
        });
      });

      var open = el('[data-lgx-open-cart]');
      if (open) open.addEventListener('click', function (ev) { ev.preventDefault(); document.dispatchEvent(new CustomEvent('cart:open')); });

      root.querySelectorAll('a[href="#lgx-selection"]').forEach(function (a) {
        a.addEventListener('click', function (ev) {
          var t = document.getElementById('lgx-selection');
          if (t) { ev.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        });
      });

      // Barre collante : visible une fois le bouton du hero passé, masquée sur la sélection.
      var sticky = el('[data-lgx-sticky]'), cta = el('[data-lgx-hero-cta]'), sel = el('[data-lgx-selection]');
      if (sticky && cta && sel && 'IntersectionObserver' in window) {
        var passed = false, onSel = false;
        var upd = function () { sticky.classList.toggle('is-on', passed && !onSel); };
        new IntersectionObserver(function (es) { es.forEach(function (x) { passed = !x.isIntersecting && x.boundingClientRect.top < 0; }); upd(); }).observe(cta);
        new IntersectionObserver(function (es) { es.forEach(function (x) { onSel = x.isIntersecting; }); upd(); }).observe(sel);
      }
    }

    function boot() { document.querySelectorAll('.lgx').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
